import useSWRMutation from 'swr/mutation';
import { sendRecoveryCodeRequest, type SendRecoveryCodeRequestParams } from '../requests';

export function useSendRecoveryCodeMutation() {
  const { trigger, data, isMutating, error, reset } = useSWRMutation(
    'reset-password-mutation',
    (_, { arg }: { arg: SendRecoveryCodeRequestParams }) => sendRecoveryCodeRequest(arg),
  );

  return {
    sendRecoveryCode: trigger,
    sendRecoveryCodeData: data,
    isSendingRecoveryCode: isMutating,
    resetSendRecoveryCode: reset,
    sendRecoveryCodeError: error,
  };
}
